import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Home } from '@/features/home'

const homeSearchSchema = z
  .object({
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute(
  '/_authenticated/new-vehicle/transfer-leads/'
)({
  validateSearch: homeSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/new-vehicle/transfer-leads',
        search: {
          language: 'en',
        },
      })
    }
  },
  component: Home,
})
